let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("42vdC")).then(() => parcelRequire('b4DX7'));